import { __extends } from "tslib";
import { Plot } from '../../core/plot';
import { adaptor } from './adaptor';

var RingProgress =
/** @class */
function (_super) {
  __extends(RingProgress, _super);

  function RingProgress() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 图表类型 */


    _this.type = 'ring-process';
    return _this;
  }

  RingProgress.prototype.getDefaultOptions = function () {
    return {
      percent: 0.2,
      innerRadius: 0.8,
      radius: 0.98,
      color: ['#FAAD14', '#E8EDF3'],
      statistic: {
        content: {
          style: {
            fontSize: 14,
            fontWeight: 300,
            fill: '#4D4D4D',
            textAlign: 'center',
            textBaseline: 'middle'
          },
          formatter: function formatter(_a) {
            var percent = _a.percent;
            return (percent * 100).toFixed(2) + "%";
          }
        }
      }
    };
  };
  /**
   * 获取 环形进度图 的适配器
   */


  RingProgress.prototype.getSchemaAdaptor = function () {
    return adaptor;
  };

  return RingProgress;
}(Plot);

export { RingProgress };